import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { PRIVATE_PERSON_EXPORT_REASON_REFS } from '../../export-target/export-target.constants';
import { IParcelPlacesForm } from '../parcel-places.models';
import { PidFieldConfig, PidFields } from './ii-product-identifiers.constants';
import { EPidApiKey } from './ii-product-identifiers.enums';

// Organization: always mandatory; private person: only when the export reason is a sale
export function isPidRequiredForSender(isLoyaltyRozniza: boolean, exportReasonRef: string | null): boolean {
  return !isLoyaltyRozniza || exportReasonRef === PRIVATE_PERSON_EXPORT_REASON_REFS.SaleRef;
}

export function getPidValidators({ maxLength, isAlwaysOptional }: PidFieldConfig, isRequired: boolean): ValidatorFn[] {
  return [
    ...(isRequired && !isAlwaysOptional ? [Validators.required] : []),
    Validators.maxLength(maxLength),
  ];
}

export function hasPidRequiredError(group: AbstractControl): boolean {
  return PidFields.some(({ controlName }) => !!group.get(controlName)?.errors?.required);
}

export function mapPidToApi(place: Partial<IParcelPlacesForm>): Record<EPidApiKey, string> {
  return PidFields.reduce<Record<EPidApiKey, string>>(
    (acc, { controlName, apiKey }) => ({ ...acc, [apiKey]: (place[controlName] ?? '').trim() }),
    {} as Record<EPidApiKey, string>,
  );
}
